var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogosHtml5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 111,
    viewBox: "0 0 79 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_92_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.584 21.7592L71.4378 101.814L39.3155 110.72L7.28169 101.827L0.142944 21.7592H78.584Z",
    fill: "#E44D26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3635 103.913L65.32 96.7166L71.4265 28.3055H39.3635V103.913Z",
    fill: "#F16529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4714 47.9459H39.3634V38.1259H14.7395L14.9744 40.7604L17.3881 67.8216H39.3634V58.0017H26.369L25.4714 47.9459ZM27.6847 72.7318H17.8269L19.2026 88.1506L39.3182 93.7345L39.3634 93.7222V83.5052L39.3203 83.5166L28.3839 80.5636L27.6847 72.7318Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.44092 0H12.4313V4.93043H16.9965V0H21.9871V14.9306H16.9968V9.93096H12.4316V14.9306H7.44123L7.44092 0ZM28.5494 4.95134H24.1567V0H37.9361V4.95134H33.5407V14.9306H28.5503V4.95134H28.5494ZM40.1229 0H45.3264L48.5272 5.24621L51.725 0H56.9306V14.9306H51.9605V7.53017L48.5272 12.8388H48.4411L45.0057 7.53017V14.9306H40.1229V0ZM59.4141 0H64.4061V9.99553H71.424V14.9306H59.4138V0H59.4141Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3297 67.8216H51.4219L50.2818 80.5574L39.3293 83.5135V93.7299L59.4609 88.1506L59.6085 86.4915L61.9165 60.6386L62.156 58.0017H39.3297V67.8216ZM39.3297 47.9219V47.9459H63.0495L63.2463 45.7388L63.694 40.7604L63.9286 38.1259H39.3297V47.9219Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_92_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78.7268,
    height: 111,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosHtml5);
export default __webpack_public_path__ + "static/media/logos_html-5.871a79a713ef0ea49b1d7d25dc1ea84b.svg";
export { ForwardRef as ReactComponent };